/**
 * Tenant-Routing Fixture.
 * Spec: lmm-wiki/wiki/orbit-specs/nexus-tenant-routing.md
 */

const KINDS = ['domain', 'hosting', 'game', 'vps', 'cloud'];
const DEFAULTS_BY_KIND = {
  domain: 'registrar-inwx',
  hosting: 'hosting-enhance',
  game: null,
  vps: 'vps-proxmox',
  cloud: 'cloud-argocd',
};

const persist = () => {
  if (typeof window === 'undefined') return null;
  if (!window.__ORBIT_NEXUS_ROUTING__) window.__ORBIT_NEXUS_ROUTING__ = {};
  return window.__ORBIT_NEXUS_ROUTING__;
};

export function tenantRoutingFixture(tenantId) {
  const db = persist();
  const overrides = db?.[tenantId] ?? {};
  return {
    routing: KINDS.map((kind) => ({
      kind,
      default_plugin_id: DEFAULTS_BY_KIND[kind],
      override_plugin_id: overrides[kind] ?? null,
      effective_plugin_id: overrides[kind] ?? DEFAULTS_BY_KIND[kind],
    })),
  };
}

export const NEXUS_KINDS = KINDS;
